import { Stack, Divider, Typography, Paper, Container, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import HouseOutlinedIcon from '@mui/icons-material/HouseOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Asiakas = ({ asiakasData }) => {
  const { t } = useTranslation();

  if (!asiakasData) {
    return (
      <Paper sx={{ marginTop: '1em' }}>
        <Container sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '1em',
          paddingBottom: '1em',
        }}
        >
          <PersonOffOutlinedIcon fontSize="large" />
          <Typography variant="h6">{t('asiakas.noCustomer')}</Typography>
        </Container>
      </Paper>
    );
  }

  return (
    <Paper sx={{ marginTop: '1em' }}>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '1em',
        }}
      >
        <PersonOutlineOutlinedIcon fontSize="large" />
        {
          asiakasData.etunimi && asiakasData.sukunimi
            ? (
                <Typography
                  variant="h6"
                  sx={{
                    minWidth: 0,
                    textAlign: 'center',
                    flexShrink: 1,
                    maxWidth: '50%',
                  }}
                >
                  {`${asiakasData.etunimi} ${asiakasData.sukunimi}`}
                </Typography>
              )
            : (
                <Typography
                  variant="h6"
                  sx={{
                    minWidth: 0,
                    textAlign: 'right',
                    flexShrink: 1,
                    maxWidth: '50%',
                    color: 'gray',
                  }}
                >
                  {t('asiakas.noName')}
                </Typography>
              )
        }
      </Container>
      <Stack sx={{ padding: '1em' }} divider={<Divider />} spacing={1}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <PhoneOutlinedIcon />
          <Typography sx={{ flex: 1 }}>
            {t('asiakas.phone')}
          </Typography>
          {
            asiakasData.yhteystiedot.puhelinNumero
              ? (
                  <Typography
                    sx={{
                      minWidth: 0,
                      textAlign: 'right',
                      flexShrink: 1,
                      maxWidth: '50%',
                    }}
                  >
                    {asiakasData.yhteystiedot.puhelinNumero}
                  </Typography>
                )
              : (
                  <Typography
                    sx={{
                      minWidth: 0,
                      textAlign: 'right',
                      flexShrink: 1,
                      maxWidth: '50%',
                      color: 'gray',
                    }}
                  >
                    {t('noInfo')}
                  </Typography>
                )
          }
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <EmailOutlinedIcon />
          <Typography sx={{ flex: 1 }}>
            {t('asiakas.email')}
          </Typography>
          {
            asiakasData.yhteystiedot.email
              ? (
                  <Typography
                    sx={{
                      minWidth: 0,
                      textAlign: 'right',
                      flexShrink: 1,
                      maxWidth: '50%',
                      overflowX: 'auto',
                      whiteSpace: 'nowrap',
                      cursor: 'pointer',
                    }}
                  >
                    {asiakasData.yhteystiedot.email}
                  </Typography>
                )
              : (
                  <Typography
                    sx={{
                      minWidth: 0,
                      textAlign: 'right',
                      flexShrink: 1,
                      maxWidth: '50%',
                      color: 'gray',
                    }}
                  >
                    {t('noInfo')}
                  </Typography>
                )
          }
        </Stack>
        <Accordion
          sx={{
            'boxShadow': 'none',
            'marginTop': 0,
            '&:before': {
              display: 'none',
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="address-content"
            id="address-header"
            sx={{
              'padding': 0,
              'minHeight': 0,
              'borderBottom': 'none',
              '&.Mui-expanded': {
                minHeight: 0,
                borderBottom: 'none',
              },
              '& .MuiAccordionSummary-content': {
                margin: 0,
              },
            }}
          >
            <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
              <HouseOutlinedIcon />
              <Typography sx={{ flex: 1 }}>
                {t('asiakas.address')}
              </Typography>
              {
                asiakasData.yhteystiedot.lahiosoite
                  ? (
                      <Typography
                        sx={{
                          minWidth: 0,
                          textAlign: 'right',
                          flexShrink: 1,
                          maxWidth: '50%',
                        }}
                      >
                        {asiakasData.yhteystiedot.lahiosoite}
                      </Typography>
                    )
                  : (
                      <Typography
                        sx={{
                          minWidth: 0,
                          textAlign: 'right',
                          flexShrink: 1,
                          maxWidth: '50%',
                          color: 'gray',
                        }}
                      >
                        {t('noInfo')}
                      </Typography>
                    )
              }
            </Stack>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <Divider sx={{ marginTop: '0.5em', marginBottom: '0.5em' }} />
            <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
              <LocationCityOutlinedIcon />
              <Typography sx={{ flex: 1 }}>
                {t('asiakas.postalCode')}
              </Typography>
              {
                asiakasData.yhteystiedot.postinumero
                  ? (
                      <Typography
                        sx={{
                          minWidth: 0,
                          textAlign: 'right',
                          flexShrink: 1,
                          maxWidth: '50%',
                        }}
                      >
                        {asiakasData.yhteystiedot.postinumero}
                      </Typography>
                    )
                  : (
                      <Typography
                        sx={{
                          minWidth: 0,
                          textAlign: 'right',
                          flexShrink: 1,
                          maxWidth: '50%',
                          color: 'gray',
                        }}
                      >
                        {t('noInfo')}
                      </Typography>
                    )
              }
            </Stack>
            <Divider sx={{ marginTop: '0.5em', marginBottom: '0.5em' }} />
            <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
              <LocationCityOutlinedIcon />
              <Typography sx={{ flex: 1 }}>
                {t('asiakas.city')}
              </Typography>
              {
                asiakasData.yhteystiedot.postitoimipaikka
                  ? (
                      <Typography
                        sx={{
                          minWidth: 0,
                          textAlign: 'right',
                          flexShrink: 1,
                          maxWidth: '50%',
                        }}
                      >
                        {asiakasData.yhteystiedot.postitoimipaikka}
                      </Typography>
                    )
                  : (
                      <Typography
                        sx={{
                          minWidth: 0,
                          textAlign: 'right',
                          flexShrink: 1,
                          maxWidth: '50%',
                          color: 'gray',
                        }}
                      >
                        {t('noInfo')}
                      </Typography>
                    )
              }
            </Stack>
          </AccordionDetails>
        </Accordion>
        {
          asiakasData.yrityksen_nimi
            ? (
                <Stack direction="row" alignItems="center" spacing={2}>
                  <BusinessCenterOutlinedIcon />
                  <Typography sx={{ flex: 1 }}>
                    {t('asiakas.company')}
                  </Typography>
                  {
                    asiakasData.yrityksen_nimi
                      ? (
                          <Typography
                            sx={{
                              minWidth: 0,
                              textAlign: 'right',
                              flexShrink: 1,
                              maxWidth: '50%',
                            }}
                          >
                            {asiakasData.yrityksen_nimi}
                          </Typography>
                        )
                      : (
                          <Typography
                            sx={{
                              minWidth: 0,
                              textAlign: 'right',
                              flexShrink: 1,
                              maxWidth: '50%',
                              color: 'gray',
                            }}
                          >
                            {t('noInfo')}
                          </Typography>
                        )
                  }
                </Stack>
              )
            : null
        }
      </Stack>
    </Paper>
  );
};

export default Asiakas;
